/**
 * A debounced function is called after [timeout] amount of time passes since its
 * last call. https://redd.one/blog/debounce-vs-throttle
 */
export const debounce = (callback, timeout = 100) => {
  let timer;
  const debouncedFn = (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      callback(...args);
    }, timeout);
  };
  debouncedFn.cancel = () => {
    clearTimeout(timer);
  };
  return debouncedFn;
};